import { configureStore } from '@reduxjs/toolkit';
import userReducer from './reducers/userReducer';
import { recruitApiSlice } from './apiSlices/recruitApiSlice';
import searchReducer from './reducers/searchReducer';
import listFilterReducer from './reducers/listFilterReducer';
import listPageAndSortReducer from './reducers/listPageAndSortReducer';
import recruitFormReducer from './reducers/recruitFormReducer';
import addOrUpdateRecruitReducer from './reducers/addOrUpdateRecruitReducer';
import { notesApiSlice } from './apiSlices/notesApiSlice';
import { attachmentsApiSlice } from './apiSlices/attachmentsApiSlice';
import globalSaveReducer from './reducers/globalSaveReducer';
import notesReducer from './reducers/notesReducer';
import attachmentsReducer from './reducers/attachmentsReducer';
import unSavedChangesReducer from './reducers/unSavedChangesReducer';
import timedOutReducer from './reducers/timedOutReducer';

const store = configureStore({
	reducer: {
		user: userReducer,
		search: searchReducer,
		listFilter: listFilterReducer,
		listPageAndSort: listPageAndSortReducer,
		recruitForm: recruitFormReducer,
		addOrUpdateRecruit: addOrUpdateRecruitReducer,
		globalSave: globalSaveReducer,
		notesReducer: notesReducer,
		attachmentsReducer: attachmentsReducer,
		unSavedChangesReducer: unSavedChangesReducer,
		timedOutReducer: timedOutReducer,
		[recruitApiSlice.reducerPath]: recruitApiSlice.reducer,
		[notesApiSlice.reducerPath]: notesApiSlice.reducer,
		[attachmentsApiSlice.reducerPath]: attachmentsApiSlice.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false }).concat([
			recruitApiSlice.middleware,
			notesApiSlice.middleware,
			attachmentsApiSlice.middleware,
		]),
});
export type RootState = ReturnType<typeof store.getState>;
export default store;
